import { locationReplace, model as router } from '!/router'
import { ui } from '!/skin'
import { ErrorDescription, IconNames } from '@setplex/arcana'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle>Error</AppTitle>
}

ErrorPage.displayName = 'ErrorPage'
export function ErrorPage(): JSX.Element {
  const location = useUnit(router.$location)
  const state = location?.state

  let from: string | undefined
  let error: Error | string | undefined
  let resolveError = false
  if (state != null && typeof state === 'object') {
    const params =
      'params' in state &&
      state.params != null &&
      typeof state.params === 'object'
        ? (state.params as Record<string, string>)
        : undefined

    error = 'error' in state ? (state.error as Error | string) : undefined
    from = params ? params.pathname + params.search + params.hash : undefined

    if (
      error &&
      typeof error === 'object' &&
      error.message.includes('ResolveLoadError:') // need to check message instead of `instanceof`, because history.state vaporizes custom errors
    ) {
      resolveError = true
    }
  }
  if (typeof window.ERA_CONFIG === 'undefined') {
    error = 'Looks like Era service is not available or not configured properly'
  }

  const handleButtonClick = () =>
    locationReplace(resolveError && from ? from : '/')

  return (
    <ui.PageWrapper className='error-page'>
      <ErrorDescription
        handleButtonClick={handleButtonClick}
        error={resolveError ? 'Failed to open module' : error && String(error)}
        from={from}
        buttonTitle={'Update'}
        buttonIcon={IconNames.restart}
      />
    </ui.PageWrapper>
  )
}
